// The spinner shown on every "please wait" step.
//
// This used to be an <img> pointing at loader-spinning-blue-circle.svg, which
// spun via SMIL (<animateTransform>) inside the file. The iOS WebView doesn't
// reliably advance SMIL in an <img>, so it sat frozen there. Inlining the
// markup and spinning it with CSS (@keyframes spin) works everywhere, and it
// can't fail to load once the phone has joined the sensor's no-internet
// "Sensor Setup" network.
const loadingSpinner = () => `
      <svg class="onboarding-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="200" height="200" aria-hidden="true" focusable="false">
        <circle cx="50" cy="50" r="45" fill="none" stroke="#ececec" stroke-width="7"></circle>
        <circle cx="50" cy="50" r="45" fill="none" stroke="#4065f6" stroke-width="7" stroke-dasharray="212.05750411731105 72.68583470577035"></circle>
      </svg>
`;

export default loadingSpinner;
